import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  CONTENT_SEPARATOR,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  businessDualKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
  defaultEstimatesDialog,
} from './common/planDefaults';

export const originBusinessGoVariablePlanContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Go Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['Benefit period is 12 months', 'No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue:
              PLAN_DETAILS_PLAN_PERIOD.Months12 +
              CONTENT_SEPARATOR +
              PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '12 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: businessDualKeyDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625503/spot-illustrations/illo_Origin-Variable-Business.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'Our most popular small business energy plan. Variable usage and supply rates.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-go-variable-business.html',
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
